import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-observacao-infracao',
  templateUrl: './text-observacao-infracao.component.html',
  styleUrls: ['./text-observacao-infracao.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextObservacaoInfracaoComponent implements OnInit {

  constructor() { }

  ngOnInit() { }
}
